import { DATE_RANGES, RANGE_LABELS, type DateRange } from '../lib/flightFilters';

// Pill row to switch a list between recent windows and full history.
export function DateRangeChips({
  value,
  onChange,
  counts,
}: {
  value: DateRange;
  onChange: (r: DateRange) => void;
  counts?: Record<DateRange, number>;
}) {
  return (
    <div className="flex flex-wrap gap-2">
      {DATE_RANGES.map((r) => (
        <button
          key={r}
          onClick={() => onChange(r)}
          className={`rounded-full px-3 py-1.5 text-xs font-semibold transition ${
            value === r ? 'bg-brand text-white' : 'bg-slate-100 text-ink-muted hover:bg-slate-200'
          }`}
        >
          {RANGE_LABELS[r]}
          {counts && (
            <span className={value === r ? 'ml-1.5 text-sky-100' : 'ml-1.5 text-ink-subtle'}>
              {counts[r]}
            </span>
          )}
        </button>
      ))}
    </div>
  );
}
